import { CSVLink } from 'react-csv';
import { parseGroupedRows } from '../../utilities/tables';

export default function DownloadButtonMeeting({
  new_data,
  headers,
  file,
  dataType = 'default'
}) {
  let refined_data = new_data;

  if (dataType === 'react-table') {
    refined_data = parseGroupedRows(new_data);
  }

  refined_data = refined_data.map((row) => {
    if (row.hasOwnProperty('name')) {
      const newName = row.name.replace(/"/g, '""');
      const rowObj = { ...row, name: newName };
      return rowObj;
    }
    if (row.hasOwnProperty('contact')) {
      const newName = row.contact.replace(/"/g, '""');
      const rowObj = { ...row, contact: newName };
      return rowObj;
    }
    if (row.hasOwnProperty('meeting_name')) {
      const newName = row.meeting_name.replace(/"/g, '""');
      const rowObj = { ...row, meeting_name: newName };
      return rowObj;
    }
    return row;
  });

  return (
    <div style={{ marginLeft: '10px' }}>
      <CSVLink
        data={refined_data}
        headers={headers}
        className='btn'
        style={{
          padding: '2px',
          borderStyle: 'solid',
          width: '90px',
          borderWidth: '2px',
          borderColor: 'gray'
        }}
        filename={`${file}.csv`}
      >
        Download
      </CSVLink>
    </div>
  );
}
